/* Mr. Watt — Featured slider · eigen lichte carousel, geen dependencies */
(function () {
  function init(root) {
    if (!root || root.dataset.mwReady) return;
    root.dataset.mwReady = '1';
    var viewport = root.querySelector('.mw-fs__viewport');
    var track = root.querySelector('.mw-fs__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.mw-fs__slide'));
    var n = slides.length;
    if (!track || n === 0) return;
    if (n > 1) {
      slides.forEach(function (s) { var c = s.cloneNode(true); c.dataset.clone = '1'; track.appendChild(c); });
      slides.slice().reverse().forEach(function (s) { var c = s.cloneNode(true); c.dataset.clone = '1'; track.insertBefore(c, track.firstChild); });
    }
    var all = Array.prototype.slice.call(root.querySelectorAll('.mw-fs__slide'));
    var i = n + Math.floor(n / 2);
    var animating = false;

    function offsetFor(k) {
      var s = all[k];
      return viewport.clientWidth / 2 - (s.offsetLeft + s.offsetWidth / 2);
    }
    function paint() {
      all.forEach(function (s, k) {
        var d = k - i;
        s.dataset.pos = Math.max(-2, Math.min(2, d));
        s.setAttribute('aria-hidden', d !== 0);
      });
    }
    function snap() {
      // Instant reposition without transition (used for loop wrap + resize)
      track.style.transition = 'none';
      all.forEach(function (s) { s.style.transition = 'none'; });
      paint();
      track.style.transform = 'translateX(' + offsetFor(i) + 'px)';
      void track.offsetWidth;
      track.style.transition = '';
      all.forEach(function (s) { s.style.transition = ''; });
    }
    function go(dir) {
      if (animating || n < 2) return;
      animating = true;
      i += dir; paint();
      track.style.transform = 'translateX(' + offsetFor(i) + 'px)';
      var done = false;
      function finish() {
        if (done) return; done = true;
        track.removeEventListener('transitionend', finish);
        if (i < n) { i += n; snap(); } else if (i >= 2 * n) { i -= n; snap(); }
        animating = false;
      }
      track.addEventListener('transitionend', finish);
      setTimeout(finish, 600);
    }

    root.querySelectorAll('[data-mw-prev]').forEach(function (b) { b.addEventListener('click', function () { go(-1); pause(); }); });
    root.querySelectorAll('[data-mw-next]').forEach(function (b) { b.addEventListener('click', function () { go(1); pause(); }); });
    all.forEach(function (s, k) { s.addEventListener('click', function (e) { if (k !== i && !animating) { e.preventDefault(); go(k - i); pause(); } }); });

    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); pause(); }
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { go(-1); pause(); } if (e.key === 'ArrowRight') { go(1); pause(); } });

    // Autoplay (data-autoplay="1" data-interval="4000")
    var timer = null, resume = null;
    var interval = parseInt(root.dataset.interval, 10) || 4000;
    var auto = root.dataset.autoplay === '1' && n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function play() { if (!auto || timer) return; timer = setInterval(function () { if (!document.hidden) go(1); }, interval); }
    function stop() { clearInterval(timer); timer = null; }
    function pause() { if (!auto) return; stop(); clearTimeout(resume); resume = setTimeout(play, interval * 2); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { if (auto && !resume) play(); });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function () { if (auto) play(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? play() : stop(); }); }, { threshold: 0.3 }).observe(root);
    } else play();

    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(snap, 80); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(snap);
    root.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', snap, { once: true }); });
    snap();
  }
  function initAll(scope) { (scope || document).querySelectorAll('.mw-fs').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.MwFeaturedSlider = { init: initAll };
})();
